<template>
  <div class="error-page">
    <div class="error-container">
      <h1>404</h1>
      <h2>Pagina non trovata</h2>
      <p>La pagina che stai cercando non esiste o è stata spostata.</p>
      <router-link to="/home" class="back-link">Torna alla Home</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f8f8;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.error-container {
  text-align: center;
  padding: 30px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
}

h1 {
  font-size: 80px;
  margin: 0;
  color: #e74c3c;
}

h2 {
  font-size: 24px;
  margin: 10px 0 20px;
  color: #333;
}

p {
  color: #666;
  margin-bottom: 30px;
}

.back-link {
  display: inline-block;
  padding: 10px 20px;
  background-color: #e74c3c;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.back-link:hover {
  background-color: #c0392b;
}
</style>